import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import GoogleOAuthButton from "../components/GoogleOAuthButton";
import { AppAlert, AppButton } from "../components/ui";

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [googleError, setGoogleError] = useState("");

  // Rediriger si déjà connecté
  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/');
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Effacer l'erreur quand l'utilisateur tape
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await authService.login(formData.email, formData.password);
      
      if (result.success) {
        // Rediriger vers la page principale
        navigate('/');
      }
    } catch (err) {
      setError(err.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = (errorMessage) => {
    setGoogleError(errorMessage);
  };

  return (
    <div className="min-vh-100 d-flex align-items-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="text-center mb-5">
              <img
                src="/assets/images/logo_konvergence.png"
                alt="Konvergence"
                style={{ maxHeight: '72px', width: 'auto' }}
              />
            </div>
            <div className="card shadow">
              <div className="card-body p-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold" style={{ color: '#000' }}>Connexion</h2>
                  <p className="text-muted">Accédez à votre espace de gestion</p>
                </div>

                {(error || googleError) && (
                  <AppAlert>
                    <i className="ri-error-warning-line me-2"></i>
                    {error || googleError}
                  </AppAlert>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      <i className="ri-mail-line me-2"></i>
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      placeholder="votre@email.com"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="password" className="form-label">
                      <i className="ri-lock-line me-2"></i>
                      Mot de passe
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      placeholder="••••••••"
                    />
                  </div>

                  <AppButton
                    type="submit"
                    className="w-100"
                    loading={loading}
                    loadingLabel="Connexion..."
                  >
                    <i className="ri-login-box-line me-2"></i>
                    Se connecter
                  </AppButton>
                </form>

                <div className="mt-4">
                  <GoogleOAuthButton
                    onError={handleGoogleError}
                    disabled={loading}
                  />
                </div>

                <div className="text-center mt-4">
                  <small className="text-muted">
                    <i className="ri-shield-check-line me-1"></i>
                    Connexion sécurisée
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
